import { FunctionalComponent, h } from "preact";
import { Img } from "react-image";
import styled, { css } from "styled-components";

export const Gallery = styled.div`
    height: 100%;
    overflow-y: auto;
`;
